export const storagePaths = {
  tracksRoot: 'tracks',
  legacyExerciseCatalog: (catalog: string) => catalog,
  userRoot: (userId: string) => `users/${userId}`,
  legacyUserRoot: (userId: string) => userId,
  userFile: (userId: string, fileName: string) => `users/${userId}/${fileName}`,
  legacyUserFile: (userId: string, fileName: string) => `${userId}/${fileName}`,
  userProfileImage: (userId: string) => `users/${userId}/profile-image.jpeg`,
  legacyUserProfileImage: (userId: string) => `${userId}/profile-image.jpeg`,
  userLogsRoot: (userId: string) => `users/${userId}/logs`,
  legacyUserLogsRoot: (userId: string) => `${userId}/logs`,
  userLogAudio: (userId: string, logUID: string, suffix: number | string) =>
    `users/${userId}/logs/${logUID}-${suffix}`,
  legacyUserLogAudio: (
    userId: string,
    logUID: string,
    suffix: number | string,
  ) => `${userId}/logs/${logUID}-${suffix}`,
  userPayrollRoot: (userId: string) => `users/${userId}/nominas`,
  legacyUserPayrollRoot: (userId: string) => `${userId}/nominas`,
  userPayrollFile: (userId: string, year: number, month: string) =>
    `users/${userId}/nominas/${year}/${month}`,
  legacyUserPayrollFile: (userId: string, year: number, month: string) =>
    `${userId}/nominas/${year}/${month}`,
  collectionImage: (collection: string, refId: string) =>
    `${collection}/${refId}.jpeg`,
} as const
